var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code"},[_c('canvas',{ref:"canvas",attrs:{"id":"QRCode_header","title":"扫描二维码"}}),_vm._v(" "),_c('div',{staticClass:"mask-code",on:{"click":_vm.saveCode}},[_c('i'),_c('span',[_vm._v("保存二维码")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e5f412","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/QRcode.vue
// module id = null
// module chunks = 